module.exports = __webpack_public_path__ + "media/images/emblems/Faido-coat_of_arms-f9f33c71c347d7a8d4b7eeca1b3042a6.svg";